import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { SelectBudgetType } from "../admin/configuracion/select/SelectBudgetType";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { SelectBudgetResource } from "../contract/select/SelectBudgetResource";
import { SelectBudgetSource } from "../admin/configuracion/BudgetSource/SelectBudgetSource";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY } from "../theme/Component/BasicTable";
import usePaginator from "../theme/Component/usePaginator";
import { SelectBudgetID } from "../admin/configuracion/BudgetID/SelectBudgetID";
import { SelectBudgetTypes } from "../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { ListMenu } from "../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { DetailBudget } from "./DetailBudget";
import { DropDown } from "../theme/Component/DropDown";
import AutoChart from "../../core/graph/AutoChart";

export const BudgetReport = () => {

    const _budget = useDataBean(_BudgetID);
    const { instance, lista, setLista, bean, setBean } = _budget;
    const [data, setData] = useState<any>({

    });
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [type, setType] = useState<number>(26);
    const paginador = usePaginator();
    const modalDocumentos = useModal("Documentos", MODAL_LG);
    const modalGraph = useModal("Grafica", MODAL_XL);

    // useEffect(() => {
    //     getBudgetYearByProps();
    // }, [paginador.page])
    useEffect(() => {
        paginador.setPage(1);
    }, [data])

    const getBudgetYearByProps = () => {
        console.log(data);

        if (year > 0 && data.IDBudgetType >= 0) {
            instance.getBudgetYearByProps(null, null, year, data).then(
                (resp: any) => {
                    if (resp.List) {
                        resp.List.forEach(element => {
                            element.DataBeanProperties.SaldoCDP = element.DataBeanProperties.CDPValue - element.DataBeanProperties.RPValue;
                            element.DataBeanProperties.SaldoOB = element.DataBeanProperties.SaldoCDP - element.DataBeanProperties.OBValue;
                        });
                        setLista(resp.List);
                        paginador.setPages(resp.NumberOfPages);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año y tipo de presupuesto obligatorio");
        }
    }

    const head25 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'Austeridad', property: 'IsAusterity', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },
        { title: 'RCDP', property: 'RCDPValue', visible: true, mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
        // { title: 'Reserva', property: 'SaldoCDP', visible: true, mask: MASK_MONEY },
        // { title: 'Cuentas por Pagar', property: 'SaldoOB', visible: true, mask: MASK_MONEY },
        { title: 'OB', property: 'OBValue', visible: true, mask: MASK_MONEY },
        { title: 'OB', property: 'OBValue', visible: true, mask: MASK_MONEY },
        { title: 'CE', property: 'CEValue', visible: true, mask: MASK_MONEY },

    ]
    const head26 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'Austeridad', property: 'IsAusterity', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },

        { title: 'IAD', property: 'IADValue', visible: true, mask: MASK_MONEY },
        { title: 'ACM', property: 'ACMValue', visible: true, mask: MASK_MONEY },
        { title: 'AP', property: 'APValue', visible: true, mask: MASK_MONEY },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documentos', icono: 'ri-git-merge-line', visible: true, evento: () => { modalDocumentos.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Reporte Presupuesto">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetTypes label="Tipo Presupuesto" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetResource idSelector={data.IDBudgetResource} onChange={(e) => { setData({ ...data, "IDBudgetResource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetSource idSelector={data.IDBudgetSource} onChange={(e) => { setData({ ...data, "IDBudgetSource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-4">
                    <SelectBudgetID jsonCode={data.BudgetIDStr} onChange={(e) => { setData({ ...data, "BudgetIDStr": e.JsonCode }) }} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mt-3">
                    <BasicButton icon="" eventClick={getBudgetYearByProps}>Buscar</BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={type == 25 ? head26 : head25} body={lista} rowSet={setBean} listButtons={listaBotones()}
                    // pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalDocumentos.modal} updateModal={modalDocumentos.setModal}>
                        <DetailBudget budget={bean.BudgetIDStr} year={year} />
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={type == 25 ? head26 : head25} useIndexAsXLabel={true}
                            xOptions={['NameBudgetType', 'BudgetIDStr', 'NameBudgetResource', 'NameBudgetSource', 'IsAusterity']}
                            yOptions={['PIValue', 'CCValue', 'CDPValue', 'RCDPValue', 'RPValue', 'OBValue', 'CEValue']} />

                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}